import { React, useCallback, useEffect, useState } from "react";
import TransTable from "../common/TransTable";
import {
  Box,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { PageTitle } from "../common/PageTitle";
import { useLocation, useNavigate } from "react-router-dom";
import Capsule from "../common/Capsule";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import ModalPopUp from "../common/TransForm/ModalPopUp";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { Notification } from "../common/Notification";

function PlayersDetails() {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  let { state } = location;
  const [activePot, setActivepot] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [notification, setnotification] = useState(false);

  const handleNavigate = (data) => {
    navigate('player_id', { state: { 'player_details': state, 'data': data } });
  };

  const roundStatusCapsule = (status) => {
    const map = {
      Active:   { bg: '#21965333', color: '#219653' },
      Completed: { bg: '#3C50E014', color: '#3C50E0' },
      Closed:   { bg: '#87878714', color: '#64748B' },
    };
    const style = map[status] || { bg: '#87878714', color: '#64748B' };
    return <Capsule data={status || '-'} bgColor={style.bg} color={style.color} />;
  };

  const pickStatusCapsule = (status) => {
    const map = {
      Win:     { bg: '#21965333', color: '#219653' },
      Lost:    { bg: '#96592114', color: '#965921' },
      Active:  { bg: '#21965333', color: '#219653' },
      JackPot: { bg: '#21965333', color: '#219653' },
    };
    const style = map[status] || { bg: '#87878714', color: '#64748B' };
    return <Capsule data={status || '-'} bgColor={style.bg} color={style.color} />;
  };

  const userTableColumns = [
    {
      key: "pot_id", label: "Round ID", align: "left", fontSize: "15px",
      valueRenderer: (data) => (
        <Typography
          style={{ color: "#3C50E0", textUnderlineOffset: 7, textDecoration: 'underline', cursor: 'pointer', width: '80px' }}
          onClick={() => handleNavigate(data)}
        >
          {data["pot_id"]}
        </Typography>
      ),
    },
    { key: "name", label: "Round Name", align: "left", fontSize: "15px" },
    { key: "category", label: "Category", align: "left", fontSize: "15px" },
    { key: "leaguename", label: "League", align: "left", fontSize: "15px" },
    {
      key: "status", label: "Round Status", align: "left", fontSize: "15px",
      valueRenderer: (data) => roundStatusCapsule(data.status),
    },
    { key: "last_match_week", label: "Last Match Week", align: "left", fontSize: "15px",
      valueRenderer: (data) => <Typography>{data.last_match_week || '-'}</Typography>,
    },
    { key: "no_of_picks", label: "No. of Picks", align: "left", fontSize: "15px" },
    {
      key: "current_pot_value", label: "Pot Value", align: "left", fontSize: "15px",
      valueRenderer: (data) => `${data['pot_currency']}  ${data['current_pot_value']}`,
    },
    {
      key: "pick_status", label: "Player Status", align: "left", fontSize: "15px",
      valueRenderer: (data) => pickStatusCapsule(data.pick_status),
    },
    {
      key: "prize_amount", label: "Prize Amount Per Winner", align: "left", fontSize: "15px",
      valueRenderer: (data) => `${data['pot_currency']}  ${data['prize_amount']}`,
    },
  ];

  const getUsers = useCallback(async () => {
    try {
      setLoading(true);
      const response = await Axios.get(
        `${base_url}/api/pot/playerpots?player=${state?.id}`,
        Config
      );
      if (response?.status == 200) {
        setActivepot(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setnotification);
    }
  }, []);

  useEffect(() => {
    getUsers();
  }, []);

  const infoItem = (label, value) => (
    <Box sx={{ minWidth: '180px', mb: 1 }}>
      <Typography sx={{ fontSize: '12px', color: '#64748B', mb: 0.3 }}>{label}</Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>{value || '-'}</Typography>
    </Box>
  );

  const playerStatus = state?.is_active
    ? <Capsule data='Active' bgColor='#21965333' color='#219653' />
    : <Capsule data='Inactive' bgColor='#87878714' color='#64748B' />;

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>

      {/* Page title */}
      <Stack direction="row" sx={{ justifyContent: "space-between", px: 6, pt: 3 }} alignContent="center">
        <PageTitle pageTitle={"Player Details"} />
      </Stack>

      {/* Player summary card */}
      <Box sx={{ mx: 6, mt: 1, mb: 3, p: 3, border: '1px solid #E2E8F0', borderRadius: '8px', backgroundColor: '#FAFAFA' }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 2 }}>
          {infoItem('Username', state?.username)}
          {infoItem('Full Name', `${state?.first_name || ''} ${state?.last_name || ''}`.trim())}
          {infoItem('Email', state?.email)}
          {infoItem('Mobile', state?.mobile_number)}
          <Box sx={{ minWidth: '180px', mb: 1 }}>
            <Typography sx={{ fontSize: '12px', color: '#64748B', mb: 0.3 }}>Status</Typography>
            {playerStatus}
          </Box>
        </Box>
        <Divider sx={{ my: 1.5 }} />
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
          {infoItem('Available Tokens', state?.available_tokens)}
          {infoItem('Won Tokens', state?.won_tokens)}
          {infoItem('Total Rounds', state?.total_rounds_playing)}
          {infoItem('Active Rounds', state?.active_rounds_playing)}
          {infoItem('Total Gain / Loss', state?.total_gain_loss)}
        </Box>
      </Box>

      {/* Rounds table */}
      <Stack direction="row" sx={{ justifyContent: "space-between", px: 6, pb: 1 }} alignContent="center">
        <PageTitle pageTitle={"Rounds Played"} />
      </Stack>
      <TransTable
        showSearch={false}
        checkbox={false}
        columns={userTableColumns}
        rows={activePot}
        showAddBtn={false}
        isLoading={loading}
      />

      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={'Activating pot ?'}
        subTitle={'Are you sure, you want to activate the pot'}
        onClick={() => {}}
        save={'Yes, Activate'}
        cancel={'Exit'}
        sx={{ borderRadius: '2px' }}
      />
      <Notification
        message={errorMessage}
        setopen={setnotification}
        type={"error"}
        show={notification}
      />
    </Box>
  );
}

export default PlayersDetails;
